import React from 'react'
import { useTranslate } from '../src/hooks/useTranslate'

export interface MapSearchProps {
	name?: React.ReactNode
	address?: React.ReactNode
}

export const MapSearch: React.FunctionComponent<MapSearchProps> = ({
	name,
	address,
}) => {
	const translate = useTranslate()

	return (
		<section className="mapSearch">
			<div className="mapSearch-in">
				<h2 className="mapSearch-title">{translate('mapSearch-title')}</h2>
				{name && <div className="mapSearch-name">{name}</div>}
				{address && <div className="mapSearch-address">{address}</div>}
			</div>
		</section>
	)
}
